import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getSubdomainConfig, getSubdomain } from '../hooks/subdomainConfig';
import '../styles/Login.css';

function LoginPage() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const subdomainConfig = getSubdomainConfig();
  const subdomain = getSubdomain();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    setError('');

    const result = await loginWithGoogle(credentialResponse);
    
    if (result.success) {
      if (result.canOnboard || subdomain !== 'onboard') {
        navigate('/');
      } else {
        setError('Your account does not have permission to onboard employees. Please contact your administrator.');
        setLoading(false);
      }
    } else {
      setError(result.error || 'Login failed. Please try again.');
      setLoading(false);
    }
  };

  const handleGoogleError = () => {
    setError('Google login failed. Please try again.');
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="login-card"
        >
          <img 
            src={subdomainConfig?.logo?.source || 'https://i.imgur.com/DAg1a53.png'}
            alt={`${subdomainConfig.companyName} Logo`}
            className="login-logo"
          />
          
          <h1>Employee Portal</h1>
          <p className="login-subtitle">Sign in with your company Google account</p>

          {error && (
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="error-message"
            >
              {error}
            </motion.div>
          )}

          <div className="google-login-wrapper">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              useOneTap
              disabled={loading}
            />
          </div>

          {loading && (
            <div className="loading-indicator">
              <div className="spinner"></div>
              <p>Verifying credentials...</p>
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
}

export default LoginPage;